import React, { useState, useEffect, useCallback } from "react";
import _ from "lodash";
import Socket from "socket";
import { motion } from "framer-motion/dist/framer-motion";

import {
  divVariants,
  logoEntryVariants,
  bounce_entry_right_variants
} from "shared/components/animations";
import promptIcon from "assets/images/gah/prompt.png";
import rectSmall from "assets/images/gah/rectangle-small.png";

const PrePlayActive = ({ roomId }) => {
  const [isFlipped, setIsFlipped] = useState(false);
  const [opacityValue, setOpacityValue] = useState("");

  useEffect(() => {
    if (isFlipped) {
      setTimeout(() => {
        setOpacityValue("opacityZero");
      }, 650);
    }
  }, [isFlipped]);

  const flipAction = () => {
    setIsFlipped(true);
    const data = {
      action: "update-status",
      roomId: roomId
    };
    Socket.sendMessage(data);
  };

  const handleFlip = useCallback(
    _.debounce(flipAction, 800, { leading: true }),
    []
  );

  return (
    <motion.div
      variants={divVariants}
      initial="hidden"
      animate="visible"
      exit="exit"
      className="gah-pre-play-active"
    >
      <motion.div
        variants={logoEntryVariants}
        className="top-lobby-banner active"
      >
        <img alt="" src={rectSmall} className="banner-icon" />
        <h2>You're in Charge!</h2>
        <img alt="" src={promptIcon} className="prompt" />
      </motion.div>

      <motion.div
        variants={bounce_entry_right_variants}
        className={`pre-play-div ${
          isFlipped ? "flipOutY" : ""
        } ${opacityValue}`}
      >
        <div className="border-div" />
        <h2 className="primary-text">GIFs Against Society</h2>
        <div className="flip-div" onClick={() => handleFlip()}>
          <div className="button-border-div" />
          <h2>FLIP</h2>
        </div>
      </motion.div>
    </motion.div>
  );
};

export default PrePlayActive;
